import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import Debug from 'debug';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import * as fromActions from '../actions/admin-manageProductContent.actions';
import { ManageProductsResponse } from '../models/manageProductContent/managedProductsResponse.model';
import { ProductCategoriesUpdateResponse } from '../models/manageProductContent/updateProductCategories.model';
import { ProductContentUpdateResponse } from '../models/manageProductContent/updateProductContent.model';
import { AdminManageProductContentService } from '../services/admin-manageProductContent.service';

const debug = Debug('modeso:modeso-lib-admin-fe:AdminManageProductContentEffects');

@Injectable()
export class AdminManageProductContentEffects {
    constructor(
        private actions$: Actions,
        private service: AdminManageProductContentService,
    ) {}

    getAllProductContent$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.getAllProductContent.type),
            mergeMap(() => {
                return this.service.getAllProducts().pipe(
                    map((response: ManageProductsResponse) => {
                        return fromActions.onGetAllProductContentSuccessfully({ payload: response });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(fromActions.onGetAllProductContentFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    errorOnGetAllProductContent$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fromActions.onGetAllProductContentFailed.type),
                tap((action: fromActions.IActionWithPayload<HttpErrorResponse>) =>
                    this.handleOnLoadAllCartErrors(action.payload),
                ),
            ),
        { dispatch: false },
    );

    updateContentByProductLine$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.updateContentByProductLine.type),
            mergeMap((payload: any) => {
                debug(payload);
                return this.service.updateContentByProductLine(payload).pipe(
                    map((response: ProductContentUpdateResponse) => {
                        return fromActions.onUpdateContentByProductLineSuccessfully({ payload: response });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(fromActions.onUpdateContentByProductLineFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    errorOnUpdateContentByProductLine$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fromActions.onUpdateContentByProductLineFailed.type),
                tap((action: fromActions.IActionWithPayload<HttpErrorResponse>) =>
                    this.handleOnLoadAllCartErrors(action.payload),
                ),
            ),
        { dispatch: false },
    );

    updateProdCategory$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.updateProductCategories.type),
            mergeMap((payload: any) => {
                debug(payload);
                return this.service.updateProductCategories(payload).pipe(
                    map((response: ProductCategoriesUpdateResponse) => {
                        return fromActions.onUpdateProductCategoriesSuccessfully({ payload: response });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(fromActions.onUpdateProductCategoriesFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    errorOnUpdateProdCategory$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fromActions.onUpdateProductCategoriesFailed.type),
                tap((action: fromActions.IActionWithPayload<HttpErrorResponse>) =>
                    this.handleOnLoadAllCartErrors(action.payload),
                ),
            ),
        { dispatch: false },
    );

    handleOnLoadAllCartErrors(error) {
        debug(error);
        return error;
    }
}
